import { Component } from "react";

import "./style.scss";

class TitleBar extends Component {

    render() {
        return (
            <div className="title-bar-line">
                <h3>{this.props.title}</h3>
                <div className="line"></div>
                {this.props.children}
            </div>
        )
    }
}

export default TitleBar;